<template>
	<div class="version-update-box">
        <!-- <section class="intro flexBox">
            <img src="/static/images/update_01.png" v-if="showIndex === 0" :key="0">
            <img src="/static/images/update_02.png" v-if="showIndex === 1" :key="1">
            <img src="/static/images/update_03.png" v-if="showIndex === 2" :key="2">

            <span class="switch-btn" @click="switchImg" v-text="showIndex !== 2 ? '下一步' : '立即体验'"></span>
        </section> -->
        <section class="intro flexBox">
            <div class="box flexBox">
                <img src="/static/images/update_01.png" :style="styleObj">
                <img src="/static/images/update_02.png" :style="styleObj">
                <img src="/static/images/update_03.png" :style="styleObj">
            </div>
            <span class="switch-btn" @click="switchImg" v-text="showIndex !== 2 ? '下一步' : '立即体验'"></span>
        </section>
    </div>
</template>

<script>
	export default {
        name: 'updateVersion',
        data() {
            return {
                showIndex: 0,
                styleObj: {
                    transform: 'translateX(0)'
                }
            }
        },
        methods: {
            switchImg() {
                if (this.showIndex === 2) {
                    localStorage.VersionUpdate_1024 = 'viewed'
                    this.$emit('viewed')
                    return
                }
                this.showIndex++

                this.styleObj.transform = `translateX(${-100 * this.showIndex}%)`
            }
        }
    }
</script>

<style lang="scss" scoped>
    .version-update-box {
        position: fixed;
        top: 0; bottom: 0;
        left: 0; right: 0;
        z-index: 12345;
        background: rgb(102, 111, 115);
        .intro {
            position: relative;
            justify-content: center;
            height: 100%;
            .box {
                width: 375px;
                height: 100%;
                overflow: hidden;
            }
            img {
                max-width: 100%;
                max-height: 100%;
                box-shadow: 0 j(10) j(40) 0 rgba(0, 0, 0, .15);
                border: 1px solid transparent;
                box-sizing: border-box;
                transition: transform .3s linear;
            }
            .switch-btn {
                position: absolute;
                bottom: j(100);
                width: j(290);
                height: j(90);
                line-height: j(90);
                font-size: j(32);
                color: #fff;
                text-align: center;
                background: #00bebe;
                border-radius: j(100);
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/versionUpdate.vue